/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 02 2023
 **/

import { css, Theme, useTheme } from "@emotion/react";
import { Typography } from "../../Typography";

export default function RecBadge() {
	const theme = useTheme();
	return (
		<div css={[defaultCss(theme)]}>
			<Typography
				typoSize="Body7"
				style={{
					color: "#fff"
				}}
			>
				REC
			</Typography>
		</div>
	);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const defaultCss = (theme: Theme) => css`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 6px;
	line-height: 6px;

	width: 30px;
	height: 18px;
	box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
	/*
	@ TODO: 디자인 가이드에 컬러규칙이 맞지 않음.
	 */
	background-color: #E73443;
;
`;
